import http from "../../tools/http";

export default {
  getAll(organizationUUID, filter) {
    return http.get(`/organizations/${organizationUUID}/integrations`, { params: filter });
  },
  getAvailable(organizationUUID) {
    return http.get(`/organizations/${organizationUUID}/integrations/available`);
  },
  getOne(organizationUUID, integrationId, uuid) {
    if (!uuid) {
      return http.get(`/organizations/${organizationUUID}/integrations/${integrationId}`);
    }
    return http.get(`/organizations/${organizationUUID}/integrations/${integrationId}/${uuid}`);
  },
  create(organizationUUID, integrationId, integration) {
    return http.post(`/organizations/${organizationUUID}/integrations/${integrationId}`, integration);
  },
  update(organizationUUID, integrationId, integration, uuid) {
    if (!uuid) {
      return http.patch(`/organizations/${organizationUUID}/integrations/${integrationId}`, integration);
    }
    return http.patch(`/organizations/${organizationUUID}/integrations/${integrationId}/${uuid}`, integration);
  },
  zendeskVerifyToken(organizationUUID, subdomain, token, email) {
    return http.post(`/organizations/${organizationUUID}/integrations/2/groups`, { subdomain, token, email });
  },
  apiGenerateNewToken(organizationUUID) {
    return http.patch(`/organizations/${organizationUUID}/integrations/4/generate`);
  },
  getWhatsappTemplates(organizationUUID, integrationUUID) {
    return http.get(`/organizations/${organizationUUID}/integrations/5/${integrationUUID}/templates`);
  }
};
